{% block swag_cms_extensions_form_editor_modal %}
    <div class="swag-cms-extensions-form-editor-modal-wrapper">
        <mt-modal-root
            :is-open="displayModal"
            @change="onModalClose(false)"
        >
            <mt-modal
                class="swag-cms-extensions-form-editor-modal"
                :title="$tc('swag-cms-extensions.sw-cms.elements.custom-form.editor.title')"
                width="l"
            >
                {% block swag_cms_extensions_form_editor_modal_content %}
                    {% block swag_cms_extensions_form_editor_modal_content_tabs %}
                        <mt-tabs
                            :key="`tabs-${activeTab}`"
                            :defaultItem="activeTab"
                            :items="tabsOptions"
                            @new-item-active="activeTab = $event"
                        />

                        <div class="swag-cms-extensions-form-editor-modal__tab-content">

                            <template v-if="activeTab === 'options'">
                                {% block swag_cms_extensions_form_editor_modal_content_tabs_item_options_content %}
                                    {% block swag_cms_extensions_form_editor_modal_content_tabs_item_options_content_technical_name %}
                                        <mt-text-field
                                            v-model="technicalName"
                                            class="swag-cms-extensions-form-editor-modal__options-technical-name"
                                            :label="$tc('swag-cms-extensions.sw-cms.elements.custom-form.editor.tabs.options.internalNameLabel')"
                                            :error="formTechnicalNameError"
                                            @change="onChangeTechnicalName"
                                            required
                                        />
                                    {% endblock %}

                                    {% block swag_cms_extensions_form_editor_modal_content_tabs_item_options_content_title %}
                                        <mt-text-field
                                            v-model="title"
                                            class="swag-cms-extensions-form-editor-modal__options-title"
                                            :label="$tc('swag-cms-extensions.sw-cms.elements.custom-form.editor.tabs.options.headlineLabel')"
                                            :error="formTitleError"
                                        />
                                    {% endblock %}

                                    {% block swag_cms_extensions_form_editor_modal_content_tabs_item_options_content_success_message %}
                                        <mt-textarea
                                            v-model="successMessage"
                                            class="swag-cms-extensions-form-editor-modal__options-success-message"
                                            :label="$tc('swag-cms-extensions.sw-cms.elements.custom-form.editor.tabs.options.confirmationTextLabel')"
                                            :error="formConfirmationTextError"
                                        />
                                    {% endblock %}

                                    {% block swag_cms_extensions_form_editor_modal_content_tabs_item_options_content_mail_receivers %}
                                        <swag-cms-extensions-multi-email-field
                                            v-model:value="receivers"
                                            class="swag-cms-extensions-form-editor-modal__options-receivers"
                                            :label="$tc('sw-cms.elements.form.config.label.receiverEmail')"
                                            :error="formReceiversError"
                                            name="mailReceiver"
                                            placeholder="john@doe.com"
                                        />
                                    {% endblock %}

                                    {% block swag_cms_extensions_form_editor_modal_content_tabs_item_options_content_mail_template %}
                                        <sw-entity-single-select
                                            v-model:value="mailTemplateId"
                                            class="swag-cms-extensions-form-editor-modal__options-mail-template-id"
                                            entity="mail_template"
                                            :criteria="mailTemplateCriteria"
                                            :label="$tc('swag-cms-extensions.sw-cms.elements.custom-form.editor.tabs.options.mailTemplateLabel')"
                                            :error="formMailTemplateIdError"
                                            valueProperty="title"
                                            labelProperty="description"
                                            required
                                        >
                                            {% block swag_cms_extensions_form_editor_modal_content_tabs_item_options_content_mail_template_selection %}
                                                <template #selection-label-property="{ item }">
                                                    <strong>{{ item.translated.description }}</strong>
                                                    <template v-if="item.translated.description">-</template>
                                                    {{ item.mailTemplateType.translated.name }}
                                                </template>
                                            {% endblock %}

                                            {% block swag_cms_extensions_form_editor_modal_content_tabs_item_options_content_mail_template_result %}
                                                <template #result-label-property="{ item, highlightSearchTerm, labelProperty, searchTerm }">
                                                    <strong>
                                                        <sw-highlight-text
                                                            :text="item.translated.description"
                                                            :searchTerm="searchTerm">
                                                        </sw-highlight-text>
                                                    </strong>
                                                    {{ item.mailTemplateType.translated.name }}
                                                </template>
                                            {% endblock %}
                                        </sw-entity-single-select>
                                    {% endblock %}
                                {% endblock %}
                            </template>

                            <template v-else-if="activeTab === 'fields'">
                                {% block swag_cms_extensions_form_editor_modal_content_tabs_item_fields_content %}
                                    {% block swag_cms_extensions_form_editor_modal_content_tabs_item_fields_content_fields %}
                                        <swag-cms-extensions-form-fields />
                                    {% endblock %}
                                {% endblock %}
                            </template>
                        </div>
                    {% endblock %}
                {% endblock %}

                {% block swag_cms_extensions_form_editor_modal_footer %}
                    <template #footer>
                        <div class="swag-cms-extensions-form-editor-modal__footer">
                            {% block swag_cms_extensions_form_editor_modal_footer_template_button %}
                                <mt-button
                                    variant="secondary"
                                    size="small"
                                    @click="onCreateTemplate"
                                >
                                    {% block swag_cms_extensions_form_editor_modal_footer_template_button_text %}
                                        {{ $tc('swag-cms-extensions.sw-cms.elements.custom-form.editor.footer.createTemplateButton') }}
                                    {% endblock %}
                                </mt-button>
                            {% endblock %}

                            {% block swag_cms_extensions_form_editor_modal_footer_close_button %}
                                <mt-button
                                    variant="primary"
                                    size="small"
                                    @click="onModalClose(true)"
                                >
                                    {% block swag_cms_extensions_form_editor_modal_footer_close_button_text %}
                                        {{ $tc('sw-cms.detail.label.buttonElementSettingsConfirm') }}
                                    {% endblock %}
                                </mt-button>
                            {% endblock %}
                        </div>
                    </template>
                {% endblock %}
            </mt-modal>
        </mt-modal-root>

        {% block swag_cms_extensions_form_template_create_modal %}
            <swag-cms-extensions-form-template-create-modal
                v-if="showCreateTemplateModal"
                @modal-close="showCreateTemplateModal = false"
            />
        {% endblock %}
    </div>
{% endblock %}
